package io.horion.cv.api.datasource.common

import kotlinx.serialization.Serializable

@Serializable
data class Signature(
    val city: String,
    val date: String,
    val image: String
)